import {
  ModalComponent,
  PermissionsList,
  SpecialPermissions,
} from "Common/Components";
import { useAssigmentSpecialPermissionStore } from "../../store";
import { useModalAssigmentSpecialPermission } from "../../hooks";
import { useTranslation } from "react-i18next";

export const ModalAssigmentSpecialPermission = () => {
  const { isOpenModal, clearAll, setIsOpenModal } =
    useAssigmentSpecialPermissionStore();
  const {
    SpecialPermissionsData,
    handleSubmit,
    handleSwitchChange,
    selectedPermission,
    setSelectedPermission,
    permissions,
    isSubmitting,
    searchTerm,
    filteredPermissions,
    setSearchTerm,
    isFormDisabled,
  } = useModalAssigmentSpecialPermission();
  const { t } = useTranslation();

  return (
    <ModalComponent
      modalTitle={t("AssigmentSpecialPermission.titleModal")}
      show={isOpenModal}
      onHide={() => {
        setIsOpenModal(false);
        clearAll();
        setSearchTerm("")
      }}
      size="xl"
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid md:grid-cols-5 gap-6">
          <PermissionsList
            permissions={filteredPermissions}
            selectedPermission={selectedPermission || 0}
            onSelect={setSelectedPermission}
            searchTerm={searchTerm}
            onSearchChange={setSearchTerm}
          />

          <SpecialPermissions
            selectedPermission={selectedPermission}
            specialPermissions={SpecialPermissionsData || []}
            permissions={permissions}
            onSwitchChange={handleSwitchChange}
          />
        </div>

        <div className="flex justify-end pt-4 border-t dark:border-zink-300/20">
          <button
            type="button"
            onClick={() => {
              setIsOpenModal(false);
              clearAll();
            }}
            className="px-4 py-2 mr-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 dark:bg-zink-700 dark:text-gray-300 dark:border-zink-500 dark:hover:bg-zink-600"
          >
            {t("AssigmentSpecialPermission.buttons.cancel")}
          </button>
          <button
            type="submit"
            disabled={isSubmitting || isFormDisabled}
            className="px-6 py-2 text-sm font-medium text-white rounded-lg bg-custom-500 hover:bg-custom-600 disabled:opacity-50 disabled:cursor-not-allowed shadow-sm shadow-custom-500/20"
          >
            {isSubmitting ? (
              <span className="flex items-center">
                {t("AssigmentSpecialPermission.buttons.process")}
              </span>
            ) : (
              t("AssigmentSpecialPermission.buttons.add")
            )}
          </button>
        </div>
      </form>
    </ModalComponent>
  );
};
